// In Signup.jsx
import React, { useState } from 'react';
import './Signup.css';

const Signup = ({ onClose, onLoginClick, onSignupSuccess }) => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [dob, setDob] = useState('');
    const [password, setPassword] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();

        // Basic validation to ensure all fields are filled
        if (!name || !email || !dob || !password) {
            alert('Please fill in all fields to sign up.');
            return;
        }

        const newUser = {
            name: name,
            email: email,
            dob: dob,
            password: password,
        };

        onSignupSuccess(newUser);
        onClose();
    };

    return (
        <div className="signup-container">
            <h2>Sign Up</h2>
            <button className="close-button" onClick={onClose}>
                X
            </button>
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="name">Name:</label>
                    <input
                        type="text"
                        id="name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="email">Email:</label>
                    <input
                        type="email"
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="dob">Date of Birth:</label>
                    <input
                        type="date"
                        id="dob"
                        value={dob}
                        onChange={(e) => setDob(e.target.value)}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="password">Password:</label>
                    <input
                        type="password"
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </div>
                <button type="submit" className="btn signup-btn">
                    Sign Up
                </button>
                <p>
                    Already have an account?{' '}
                    <button className="link-button" onClick={onLoginClick}>
                        Log In
                    </button>
                </p>
            </form>
        </div>
    );
};

export default Signup;
